import lng from '@lightningjs/core';
import { Colors, Router } from '@lightningjs/sdk';
import { getDevice } from '../../../../utils/device';

export default class Button extends lng.Component {
  static _template() {
    return {
      collision: true,
      rect: true,
      w: 235,
      h: 75,
      y: 600,
      color: Colors('#292929').get(),
      texture: lng.Tools.getRoundRect(235, 75, 12, 3, false),
      Wrapper: {
        w: 235,
        h: 75,
        y: 3,
        flex: { justifyContent: 'center', alignItems: 'center' },
        Text: {},
      },
      ButtonBorder: {},
    };
  }

  get _Text() {
    return this.tag('Text');
  }

  get _ButtonBorder() {
    return this.tag('ButtonBorder');
  }

  set option({ title, id }) {
    return (this._option = { title, id });
  }

  set index(val) {
    this._index = val;
  }

  _firstEnable() {
    this._Text.patch({
      text: {
        text: this._option.title,
        fontSize: 32,
      },
    });
    this._ButtonBorder.patch({
      w: 235,
      h: 75,
      texture: lng.Tools.getRoundRect(240, 80, 12, 3, Colors('#D6D6D7').get(), false),
    });
  }

  _focus() {
    super._focus();
    this._ButtonBorder.patch({
      texture: lng.Tools.getRoundRect(240, 80, 12, 3, Colors('#02AC25').get(), false),
    });
  }

  _unfocus() {
    super._unfocus();
    this._ButtonBorder.patch({
      texture: lng.Tools.getRoundRect(235, 75, 12, 3, Colors('#D6D6D7').get(), false),
    });
  }

  _handleEnter() {
    switch (this._option.id) {
      case 1:
        // Router navigation for "No, resume"
        Router.back();
        break;
      case 2:
        const device = getDevice();
        // Router navigation for "Yes, exit now"
        if (device === 'tizen') {
          window.tizen.application.getCurrentApplication().exit();
        } else if (device === 'web') {
          window.location.href = '';
        } else if (device === 'webos') {
          window.close();
        }
        break;
    }
  }

  // Magic Remote

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
}
